export default {
    label: 'Site Settings',
    name: 'site_settings',
    file: 'src/content/settings/site_settings.json',
    i18n: true,
    fields: [
        {
            label: 'Favicon',
            name: 'favicon',
            widget: 'image',
            i18n: 'duplicate'
        },
    ],
};